import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import styles from './style.module.css';
import Toast from '../../components/toast';

// An invalid URL can be arbitrarily long; keep the message readable.
const MAX_PATH_LENGTH = 60;

const truncatePath = path =>
    path.length > MAX_PATH_LENGTH ? `${path.slice(0, MAX_PATH_LENGTH)}\u2026` : path;

class DefaultPage extends Component {
    constructor(props) {
        super(props);

        const {
            location
        } = props;

        this.state = {
            invalidPath: (location.state && location.state.invalidPath) || null
        };

        this.dismissInvalidPath = this.dismissInvalidPath.bind(this);
    }

    componentWillMount() {
        const {
            props: {
                history,
                navigation
            }
        } = this;
        if (navigation.length === 1) {
            history.push(`${process.env.PUBLIC_URL}${navigation[0].path}`);
        }
    }

    componentDidMount() {
        const {
            props: {
                history,
                location
            }
        } = this;

        // The message lives in component state from here on. Strip it out of the
        // history entry so it doesn't reappear on a refresh, or when the visitor
        // navigates back to the homepage later on.
        if (location.state && location.state.invalidPath) {
            history.replace({
                pathname: location.pathname,
                search: location.search
            });
        }
    }

    dismissInvalidPath() {
        this.setState({ invalidPath: null });
    }

    render() {
        const {
            props: {
                navigation,
                secondaryMenu
            },
            state: {
                invalidPath
            }
        } = this;

        return (
            <div className={styles.page}>
                <div className={styles.contentContainer}>
                    {
                        invalidPath &&
                        <Toast
                            message={`Sorry, we couldn\u2019t find ${truncatePath(invalidPath)}. Here are all of our calculators instead.`}
                            onDismiss={this.dismissInvalidPath}
                        />
                    }
                    <h1 className={styles.mainTitle}>Financial Calculators</h1>
                    <ul className={styles.navigation}>
                        {
                            navigation.map((navItem) => (
                                <li key={navItem.path}>
                                    <Link
                                        to={process.env.PUBLIC_URL + navItem.path}
                                        title={navItem.name}
                                    >
                                        {navItem.name}
                                    </Link>
                                </li>
                            ))
                        }
                    </ul>
                    <div className={styles.calculatorMenuContainer}>
                        <ul className={styles.calculatorMenu}>
                            {
                                secondaryMenu.map((calcItem, index) =>
                                    <li key={`calcItem-${index}`}>
                                        <p>{calcItem.name}</p>
                                        <ul className={styles.calculatorItems}>
                                            {
                                                calcItem.routes.map((calcList, i) =>
                                                    <li key={`calcList-${index}-${i}`}>
                                                        <Link
                                                            to={process.env.PUBLIC_URL + calcItem.path + calcList.path}
                                                            title={calcList.name}
                                                        >
                                                            {calcList.name}
                                                        </Link>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(DefaultPage);
